export interface OrderRecipient {
  name: string;
  phone: string;
  email: string;
  address: string;
  pvz_id: number | null;
}

export interface DeliveryInfo {
  provider: string;
  amount: number;
  type: string;
  city: string;
  pvz: string;
  pvz_id: number | null;
}

export const initialRecipientData: OrderRecipient = {
  name: '',
  phone: '',
  email: '',
  address: '',
  pvz_id: null
};

export const initialDeliveryInfo: DeliveryInfo = {
  provider: '',
  amount: 0,
  type: '',
  city: '',
  pvz: '',
  pvz_id: null
};
